export default __webpack_public_path__ + "static/media/mobydickKlein.625eecca.jpg";